import momentEU from 'moment/locale/eu'

const components = {
  momentName: 'eu',
  momentLocale: momentEU
}

const locale = {
  'message': '-',
  'layouts.EmailMarketing': 'EmailMarketing',
  'layouts.riseSuddenlyAndSharply': 'Rise Suddenly And Sharply',
  'layouts.应用市场': 'App Store',
  'layouts.易学堂（直播/回放）': 'Yixuetang (live/replay)',
  'layouts.直播/回放': 'Live streaming/replay',
  'layouts.本服务适合': 'This service is suitable for sellers who have eaby or independent websites',
  'layouts.可打通多平台数据': 'private domain traffic can be accurately marketed by email, with an ROI of up to',
  'layouts.application': 'Application',
  'layouts.current': 'Current',
  'layouts.去开通': 'Go open',
  'layouts.已开通系统': 'The system that has been opened',
  'layouts.推荐开通系统': 'Recommended system',
  'layouts.可选择切换导航菜单': 'Switch navigation menus',
  'layouts.switch': 'Switch {0}',
  'layouts.old.version': 'Old',
  'layouts.new.version': 'New',
  'layouts.new': 'New',
  'layouts.edit': 'Edit',
  'layouts.show': 'Show {0}',
  'layouts.hide': 'Hide {0}',
  'layouts.paidPage': 'paid page',
  'layouts.expired': 'Expired',
  'layouts.upgrade': 'Upgrade',
  'layouts.buy': 'Buy',
  'layouts.onlineservice': 'Online Service',
  'layouts.exportcenterhere': 'The export center is here',
  'layouts.exportcenter': 'Export Center',
  'layouts.MoneyAssistant': 'Financ Manage',
  'layouts.accountSettings': 'Account Settings',
  'layouts.usercenter': 'User Center',
  'layouts.productPackage': 'Product Package',
  'layouts.authority': 'Authority Management',
  'layouts.store.authorization': 'Store Authorization',
  'layouts.helpcenter': 'Help Center',
  'layouts.menusyl': 'Menu Style',
  'layouts.menusyl.top': 'Top menu layout',
  'layouts.menusyl.left': 'Side menu layout',
  'layouts.langset': 'Language settings',
  'layouts.menutransformation': 'Menu Change',
  'layouts.logout': 'Logout',
  'layouts.allapplication': 'Applications',
  'layouts.history': 'history',
  'layouts.maylike': 'Guess what you want to search for, it may be the name of the menu after moving',
  'layouts.customscene': '{0} Custom Scene',
  'layouts.demo.tips': 'The DEMO environment does not support this operation. You can use your own account to operate this function',
  'layouts.customscene.currentNoDel': 'The scene in use is not allowed to be deleted. Please switch to another scene before deleting',
  'layouts.allmenu': 'All Menu',
  'layouts.menusearch': 'Please enter keywords, search menu',
  'layouts.commonmenu': 'History',
  'layouts.search.placeholder': 'Please input keywords, search menu',
  'layouts.text.undefined': 'No data',
  'layouts.operation.guide': 'Operation guide',
  'layouts.bookmarks': 'Bookmarks',
  'layouts.bookmarks.success': 'Bookmarks successfully',
  'layouts.bookmarks.cancel': 'Unbookmarked successfully',
  'layouts.openAll': 'Open All',
  'layouts.manageFavorites': 'Manage Favorites',
  'layouts.ViewAll': 'View All',
  'layout.searchKeyword': 'Search Keyword',
  'layout.error-401': 'Sorry, if you have not enabled this function, please contact the system administrator account holder to help you activate the menu permission.',

  'layout.guideLayout.title': 'One click binding of the store, immediately start your cross-border business!',
  'layout.guideLayout.step1': 'The first step is to bind your store',
  'layout.guideLayout.p1': 'After binding the store, we will immediately start synchronizing your store\'s products and orders, so that you can start business immediately after entering the system!',
  'layout.guideLayout.p2': 'Novice guidance is only for you to quickly develop your business. After entering the system, you can still bind to other stores.',
  'layout.guideLayout.amazon.title': 'Bind the store within 7 days and receive 2000 free orders',
  'layout.guideLayout.amazon.click': 'Click to bind your Amazon store',
  'layout.guideLayout.shopify.click': 'Click to bind your Shopify store',
  'layout.guideLayout.temu.click': 'Click to bind your TEMU store',
  'layout.guideLayout.tiktok.click': 'Click to bind your Tiktok store',
  'layout.guideLayout.morePlatform': 'Stay tuned for more platforms',
  'layout.guideLayout.p3': 'Click',
  'layout.guideLayout.p4': 'here',
  'layout.guideLayout.p5': 'Enter the demonstration environment and experience the full functionality in advance!',
  'layout.guideLayout.店铺授权': 'Store authorization',
  'layout.guideLayout.bindSuccess': 'Binding successful',
  'layout.guideLayout.waitText1': 'After entering the account, we will start synchronizing your product and order data.',
  'layout.guideLayout.waitText2': 'Expected time is 5-30 minutes, please be patient.',
  'layout.guideLayout.btnBindMore': 'Bind more stores',
  'layout.guideLayout.linkJump': 'Enter immediately',

  'version-modal.title': 'Switching instructions',
  'version-modal.tips': 'This switch will not be returned to the current version, you can also check the introduction of the new version for a comprehensive understanding',
  'version-modal.info': 'After switching to Easy ERP, there will be the following changes:',
  'version-modal.subInfo-1': 'System Ul changes',
  'version-modal.subInfo-2': 'Change of menu order',
  'version-modal.subInfo-3': 'Functions may be deleted and added accordingly, but will not affect the basic business process',
  'version-modal.footer': 'I have understood the above situation and agreed to switch.',
  'version-modal.viewDemo': 'View Demo',

  'store-tip.title': 'A Sharp weapon for sealing a essential for in vogue goods',
  'store-tip.subtitle': '2 mins fast authorization',
  'store-tip.guide': 'High technology constructing accurate marketing operations',
  'store-tip.info-1': 'Multi-shops management<br>auto anti-associations',
  'store-tip.info-2': 'Live dates updating<br>safe and reliable',
  'store-tip.info-3': 'In time warning for<br>operation risks',
  'store-tip.remind': 'No more reminders for this login',
  'store-tip.btn': 'START AUTHORIZATION',

  'form-modal.cancel': 'Cancel',
  'form-modal.submit': 'Save',
  'form-modal.delete': 'Delete',
  'form-modal.selected': 'Selected',
  'form-modal.action': 'Action',
  'form-modal.third-party-abnormal': 'The third-party system is abnormal!',
  'form-modal.custom.title': 'Custom Scene menus',
  'form-modal.customMenuName': 'Scene name',
  'form-modal.system.title': 'Custom System menus',
  'form-modal.menuname.placeholder': 'Please enter a name',
  'form-modal.remark.placeholder': 'remarks',
  'form-modal.rule.maxstring': 'Supports up to {0} strings',
  'form-modal.rule.maxobject': 'Choose a maximum of 2 items',
  'form-modal.rule.select': 'Please select {0}',
  'notification-modal.title.prompt': 'Warm prompt',
  'notification-modal.content.delete.customscene': 'Are you sure to delete the scene? This operation is unrecoverable',
  'notification-modal.content.maxcustomscene': 'Up to 30 scenes can be created, and you can delete obsolete scenes or edit existing ones',
  'logout.title': 'Message',
  'logout.content': 'Are you sure you would like to logout?',
  'logout.okText': 'OK',
  'logout.cancelText': 'Cancel',

  'tabs.close.current': 'Close current tab',
  'tabs.close.right': 'Close right',
  'tabs.close.left': 'Close left',
  'tabs.close.all': 'Close all',

  'station.免费快速建站': 'Free site a construction',
  'station.专属品牌': 'Exclusive brand independent website',
  'station.多渠道': 'Multi-channel & low-price drainage',
  'station.品牌用户': 'Accumulation of brand users',
  'station.用户裂变': 'Users spread growth',
  'station.精细化运营': 'Fine management',
  'station.获取利润': 'Profit maximization',
  'station.一键建站': 'Build a website with one click',

  'station.请填写建站信息': 'Please fill in the relevant information',
  'station.您的建站信息已提交': 'The information has been submitted',
  'station.我们正在加班加点搭建中': 'We are working hard to build your website',
  'station.预计3个工作日内主动联系您': 'It is expected to contact you proactively within 3 working days',
  'station.您也可以通过扫描二维码': 'You can also contact us by scanning the QR code',
  'station.我知道了': 'I see',
  'station.请填写正确的手机号': 'Please fill in the correct phone number',
  'station.请填写正确的邮箱': 'Please fill in the correct email address',
  'station.请填写正确的姓名': 'Please fill in the correct name',
  'station.请使用已授权亚马逊店铺的账号创建独立站': 'Please use the account of an authorized Amazon store to create a website',
  'station.请同意使用刊登系统搭建独立站': 'Please agree to use the listing system to build an independent station',
  'station.请选择一个店铺': 'Please select a shop to create a website',
  'station.目前暂时只支持': 'Only Amazon',
  'station.邮箱': 'Mail',
  'station.联系人姓名': 'Name',
  'station.信息填写无误': 'Verify the information, Build a website for free',
  'station.同意使用刊登系统': 'Agree to use the listing system to build a website',
  'station.为了能更快帮助您创建独立站': 'In order to help you create a website faster, we need to use a listing system.If you have purchased the listing system(old version), we will directly use the system to help you list the product; if you have not purchased the listing system(old version), we will open a 14-day publishing system package for you for free.（https://adv-listing.eccang.com/default/index/login）',

  'EDM.邮件营销': 'EDM',
  'EDM.智能分群': 'Intelligent grouping Recommended',
  'EDM.大数据挖掘': 'Data mining',
  'EDM.千万级发送量': 'Sending volume above tens of millions',
  'EDM.自动化埋点': 'Automated statistics',
  'EDM.快捷邮件制作': 'Quick mail creation',
  'EDM.自动营销风控': 'Automatic marketing risk control',
  'EDM.立即体验': 'Experience Now',

  'empty_data': 'There are currently no unread messages',
  'authority_account_edit_password': 'Edit password',
  'common_globalcomp_login_again': 'Login again'
}

export default {
  ...components,
  ...locale
}
